/* eslint-disable */
/* eslint-disable eslint-comments/no-unused-disable */
/* 
* The file is automatically generated by Serenity UI.
* 
* ⚠️ WARNING: Any manual changes may be overwritten during the next upgrade
* 
* Found an issue? Submit a task to the ClickUp board:
* https://app.clickup.com/1255586/v/l/6-901510012553-1?pr=90154030902
*/
import * as stylex from '@stylexjs/stylex';
import { type ForwardedRef, type ReactNode, createContext, forwardRef } from 'react';
import { Button as ButtonCore, type ButtonProps as ButtonCoreProps, Collection, type ContextValue, DEFAULT_SLOT, Provider, useContextProps } from 'react-aria-components';
import { $ } from '../../tokens.stylex';
import { AvatarContext } from '../avatar/avatar.component';
import { Text, TextContext } from '../text/text.component';

interface ReactionButtonProps<T extends object = object> extends Omit<ButtonCoreProps, 'children' | 'style' | 'className'> {
  /** Item objects in the collection. */
  items?: Iterable<T>;
  style?: stylex.StyleXStyles;
  children?: ReactNode | ((item: T) => ReactNode);
}

const ReactionButtonContext = createContext<ContextValue<ReactionButtonProps, HTMLButtonElement>>({});

const ReactionButton = forwardRef((props: ReactionButtonProps, ref: ForwardedRef<HTMLButtonElement>) => {
  [props, ref] = useContextProps(props, ref, ReactionButtonContext);

  const { style, items, children, ...coreProps } = props;

  const itemsArray = Array.from(items ?? []);

  return (
    <ButtonCore
      ref={ref}
      {...stylex.props(styles.base, style)}
      {...coreProps}>
      <Provider values={[
        [AvatarContext, {
          size: 20,
          style: avatarStyles.base,
        }],
        [TextContext, {
          slots: {
            [DEFAULT_SLOT]: {
              size: 12,
              weight: 'medium',
              color: 'tertiary',
            },
          }
        }],
      ]}>
        {typeof children === 'function'
          ? (
            <>
              <Collection items={items}>{children}</Collection>
              {itemsArray.length > 0 && <Text>{itemsArray.length}</Text>}
            </>
          )
          : children}
      </Provider>
    </ButtonCore>
  );
}) as <T extends object>(props: ReactionButtonProps<T> & { ref?: ForwardedRef<HTMLButtonElement> }) => React.ReactElement;

const styles = stylex.create({
  base: {
    borderColor: $.surface02,
    borderRadius: 100,
    borderStyle: 'solid',
    borderWidth: 2,
    gap: 4,
    paddingBlock: 4,
    alignItems: 'center',
    backgroundColor: $.surface00,
    cursor: {
      default: 'pointer',
      ':is([data-disabled])': 'not-allowed',
      ':is([data-pending])': 'wait',
    },
    display: 'inline-flex',
    paddingLeft: 6,
    paddingRight: 8,
  },
});

const avatarStyles = stylex.create({
  base: {
    borderColor: $.surface00,
    borderStyle: 'solid',
    borderWidth: 1,
    marginLeft: {
      default: 0,
      ':not(:first-child)': -10,
    },
  },
});

export { ReactionButton, ReactionButtonContext, type ReactionButtonProps };
